import { useEffect } from 'react';
import { KeyboardData, useKeyboardStore } from './stores/keyboardStore';

export const keyboardCoreHooks = () => {
  const [keyboard, setKeyboard] = useKeyboardStore<KeyboardData>();

  const handleKeyDown = (e: KeyboardEvent) => {
    if ((e.ctrlKey && e.code === 'KeyS') || e.altKey) {
      e.preventDefault();
      return null;
    }

    const activeElement = document.activeElement;
    if (activeElement?.tagName === 'INPUT' || activeElement?.tagName === 'TEXTAREA') return;

    // Clear any "stuck" modifier keys if they're not actually pressed
    let currentKeysDown = [...(keyboard.keysDown || [])];

    if (!e.metaKey) {
      currentKeysDown = currentKeysDown.filter(key => !key.includes('Meta'));
    }
    if (!e.ctrlKey) {
      currentKeysDown = currentKeysDown.filter(key => !key.includes('Control'));
    }
    if (!e.altKey) {
      currentKeysDown = currentKeysDown.filter(key => !key.includes('Alt'));
    }
    if (!e.shiftKey) {
      currentKeysDown = currentKeysDown.filter(key => !key.includes('Shift'));
    }

    if (keyboard.keysDown?.includes(e.code)) return;
    setKeyboard({
      keysDown: [...currentKeysDown, e.code],
      keysUp: [],
    });
  };

  const handleKeyUp = (e: KeyboardEvent) => {
    // Clear keyboard state when any modifier key is released
    if (e.code === 'MetaLeft' || e.code === 'MetaRight' || 
        e.code === 'ControlLeft' || e.code === 'ControlRight' || 
        e.code === 'AltLeft' || e.code === 'AltRight' || 
        e.code === 'ShiftLeft' || e.code === 'ShiftRight') {
      setKeyboard({
        keysDown: [],
        keysUp: [],
      });
      return;
    }

    setKeyboard({
      keysDown: keyboard.keysDown.filter((key) => key !== e.code),
      keysUp: [...keyboard.keysDown],
    });
  };

  const handleBlur = () => {
    setKeyboard({
      keysDown: [],
      keysUp: [],
    });
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    window.addEventListener('blur', handleBlur);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
      window.removeEventListener('blur', handleBlur);
    };
  });
};
